export var EDIT_AREA_ID = 'ak-editor-textarea';